import { useSelector } from 'react-redux'

export const environmentSelector = state => state?.initialLoad?.environment
export const useEnvironment = () => useSelector(environmentSelector)
